import * as searchTypes from './searchType'
import useSearch from './useSearch'
import SearchForm from './searchForm/searchForm'

import EditIcon from '@material-ui/icons/Edit'
import { IconButton, Paper, Grid, Theme, createStyles, Typography, Tooltip, Container } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../utilities/date'
import React from 'react'
import { ItemListType } from '../../../../services/web/types/responseWebServiceTypes'
import { statusColorConstant } from '../../../../constants/constants'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useAuthenStore from '../../../../stores/authen/authenStore'
import useTranslate from '../../../../i18n/useTranslate'
import { ButtonView } from '../../../../control/button/button'
import SearchAccordion from '../../../../control/accordion/SearchAccordion'

import constUserGroup from '../../../../constants/userGroup'
import projectStatus from '../../../../constants/projectStatus'
import Result from './searchResult/Result'
import Dashboard from './dashboard/NewDashboard'
// import {convertDateToFormatTH} from '../../../../utilities/date'
//View
const SearchView = (props: searchTypes.SearchViewType) => {
    const {
        listItem,
        isSumItem,
        // isShowForm,
        isResearcher,
        isChairman,
        rowPerpage,
        // currentListIndex,
        isGotoTop,
        getListItem,
        onClickEdit,
        onClickCreate,
        onClickSearch,
        handleClickGotoTop,
        // onClickPagination,
        onClickClear,
        // onClickSort,
        handleScrollEnd,
        initialValueForm,
        currentListIndexRef,
        pendingProps,
    } = props
    const theme = useTheme()
    const statusColorRef = React.useRef('')
    const classes = useStyles({ statusColorRef })
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))
    const authenStore = useAuthenStore()
    const { profile } = authenStore
    const translate = useTranslate()
    const isIrb1 = Number(profile?.irb) === 1

    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const handleScroll = (event: any) => {
        const wrappedElement = document.getElementById('searchDiv')
        if (isBottom(wrappedElement)) {
            window.removeEventListener('scroll', handleScroll)
            handleScrollEnd(rowPerpage * (currentListIndexRef.current + 1), currentListIndexRef.current + 1)
            setTimeout(() => {
                window.addEventListener('scroll', handleScroll, { passive: true })
            }, 1000)
        }
    }

    const isBottom = (el: any) => {
        return el?.getBoundingClientRect().bottom - window.innerHeight * 0.01 <= window.innerHeight
    }

    const rowRenderer = (props: any) => {
        const {
            key, // Unique key within array of rows
            index, // Index of row within collection
            style, // Style object to be applied to row (to position it)
        } = props

        return (
            <Grid container key={key} style={style}>
                {isMobileView ? renderListElementMobile(listItem[index], key) : renderListElement(listItem[index], key)}
            </Grid>
        )
    }
    const getDisplayResearcherName = (val: ItemListType) => {
        let displayResearcherName = ''
        if (translate.languageStore.currentLanguage === translate.languageKey.th) {
            displayResearcherName = val.researcherName_th ?? '-'
            if (val.researcherTypeName_th) {
                displayResearcherName += ` (${val.researcherTypeName_th ?? ''})`
            }
        } else {
            displayResearcherName = val.researcherName_en ?? '-'
            if (val.researcherTypeName_en) {
                displayResearcherName += ` (${val.researcherTypeName_en ?? ''})`
            }
        }
        return displayResearcherName
    }
    const getDisplayProjectName = (val: ItemListType) => {
        let displayProjectName = ''
        if (translate.languageStore.currentLanguage === translate.languageKey.th) {
            displayProjectName = val.projectName_th ? val.projectName_th : '-'
        } else {
            displayProjectName = val.projectName_en ? val.projectName_en : '-'
        }
        return displayProjectName
    }
    const getDisplayProjectStatus = (val: ItemListType) => {
        let displayStatus = ''

        // if (
        //     val.projectStatusID === constProjectStatus.closed || //ปิดโครงการ
        //     val.projectStatusID === constProjectStatus.rejected || //ไม่อนุมัติ
        //     val.projectStatusID === constProjectStatus.notScope || //ไม่เข้าข่าย
        //     val.projectStatusID === constProjectStatus.terminate //ยุติโครงการ
        // ) {
        //     if (translate.languageStore.currentLanguage === translate.languageKey.th) {
        //         displayStatus = val.projectStatus_th ?? '-'
        //     } else {
        //         displayStatus = val.projectStatus_en ?? '-'
        //     }
        // } else {
        //     if (val.submittedStatus_th && val.submittedStatus_en) {
        //         if (translate.languageStore.currentLanguage === translate.languageKey.th) {
        //             displayStatus = val.submittedStatus_th ?? '-'
        //         } else {
        //             displayStatus = val.submittedStatus_en ?? '-'
        //         }
        //     } else {
        //         displayStatus = translate.get('LABEL.DRAFT')
        //     }
        // }
        if (translate.languageStore.currentLanguage === translate.languageKey.th) {
            displayStatus = val.projectStatus_th ?? '-'
        } else {
            displayStatus = val.projectStatus_en ?? '-'
        }
        return displayStatus
    }

    const getDisplaySubmittedDate = (val: ItemListType) => {
        let display = '-'
        if (val?.submittedDate) {
            display =
                translate.languageStore.currentLanguage === translate.languageKey.th
                    ? convertDateToFormatTH(val.submittedDate)
                    : convertDateToFormatEN(val.submittedDate)
        }
        return display
    }

    const renderListElementMobile = (itm: ItemListType, key: number) => {
        const { submittedStatusColor, projectStatusBackgroundColor, statusTextColor } = checkStatusColor(itm)

        return (
            <Grid item xs={12}>
                <Paper
                    className={classes.paperList}
                    variant="outlined"
                    style={{ padding: '25px', margin: '0px', marginRight: '0px' }}
                    onClick={() => onClickEdit(itm)}
                >
                    <Grid container>
                        <Grid container item xs={2} alignItems="center">
                            <IconButton aria-label="InfoIcon">
                                <EditIcon fontSize={'small'} />
                            </IconButton>
                        </Grid>
                        <Grid container item xs={8} alignItems="center">
                            <Grid container item xs={12}>
                                <Grid item xs={12}>
                                    <Typography variant={'body2'} style={{ fontWeight: 'bold' }}>
                                        {itm.projectCode ? itm.projectCode.split('.')[1] : ''}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography noWrap variant={'body2'}>
                                    {getDisplayProjectName(itm)}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container item xs={2} alignItems="center" justify={'flex-end'}>
                            <Paper
                                variant="outlined"
                                className={classes.paperProjectStatusMobile}
                                style={{ background: `${projectStatusBackgroundColor}`, color: `${statusTextColor}` }}
                            ></Paper>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        )
    }
    const renderListElement = (itm: ItemListType, key: number) => {
        const { projectStatusBackgroundColor, submittedStatusColor, statusTextColor } = checkStatusColor(itm)

        const isDirector = profile.userGroupId === constUserGroup.committee
        const isResearcher = profile.userGroupId === constUserGroup.researcher
        const isProcessing = itm.projectStatusID === projectStatus.processing
        const padding = isProcessing && !isResearcher ? '10px 25px 10px 25px' : '25px'
        const submitTypeName =
            translate.languageStore.currentLanguage === translate.languageKey.th
                ? (itm.submittedStatus_th ?? '-')
                : (itm.submittedStatus_en ?? '-')
        return (
            <Grid item xs={12}>
                <Paper
                    variant="outlined"
                    style={{ padding: padding, margin: '0px', marginRight: '0px' }}
                    onClick={() => onClickEdit(itm)}
                    className={classes.hoverRow}
                >
                    <Grid container spacing={2}>
                        <Grid container item xs={1} alignItems="center">
                            <ButtonView className={classes.btnEdit}>{translate.get('BUTTON.EDIT')}</ButtonView>
                        </Grid>
                        <Grid container item xs={2} alignItems="center">
                            <Paper variant="outlined" className={classes.paperProjectCode}>
                                <Typography noWrap variant={'body2'} style={{ fontWeight: 'bold' }}>
                                    {itm?.projectNumber}
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid container item xs={isResearcher ? 4 : 3} alignItems="center">
                            <Grid item xs={12}>
                                <Typography noWrap variant={'body2'} style={{ fontWeight: 'bold' }}>
                                    {getDisplayResearcherName(itm)}
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography noWrap variant={'body2'} title={getDisplayProjectName(itm)}>
                                    {getDisplayProjectName(itm)}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container item xs={isResearcher ? 3 : 2} alignItems="center">
                            <Grid item xs={12}>
                                <Typography
                                    className={classes.multiLineEllipsis}
                                    variant={'body2'}
                                    style={{ fontWeight: 'bold' }}
                                >
                                    {translate.languageStore.currentLanguage === translate.languageKey.th
                                        ? itm.submitTypeName_th || '-'
                                        : itm.submitTypeName_en || '-'}
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography className={classes.multiLineEllipsis} variant={'body2'}>
                                    {translate.get('LABEL.SUBMITTED_DATE')} {getDisplaySubmittedDate(itm)}
                                </Typography>
                            </Grid>
                        </Grid>

                        {!isResearcher && (
                            <Grid container item xs={isResearcher ? 3 : 2} alignItems="center">
                                <Grid item xs={12}>
                                    <Typography
                                        className={classes.multiLineEllipsis}
                                        variant={'body2'}
                                        style={{ fontWeight: 'bold' }}
                                    >
                                        {isDirector
                                            ? translate.get('LABEL.COMMITTEE_MEETING_DATE')
                                            : translate.get('LABEL.EXPECTED_ANNOUNCEMENT_DATE')}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography className={classes.multiLineEllipsis} variant={'body2'}>
                                        {isDirector
                                            ? itm.committeeDueDate
                                                ? translate.languageStore.currentLanguage === translate.languageKey.th
                                                    ? convertDateToFormatTH(itm.committeeDueDate)
                                                    : convertDateToFormatEN(itm.committeeDueDate)
                                                : '-'
                                            : itm.announceDate
                                              ? translate.languageStore.currentLanguage === translate.languageKey.th
                                                  ? convertDateToFormatTH(itm.announceDate)
                                                  : convertDateToFormatEN(itm.announceDate)
                                              : '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}

                        <Grid container item xs={2} alignItems="center">
                            <Grid container item xs={false} alignItems="center">
                                <Paper
                                    variant="outlined"
                                    className={classes.paperProjectStatus}
                                    style={{
                                        background: `${projectStatusBackgroundColor}`,
                                        color: `${statusTextColor}`,
                                    }}
                                >
                                    <Typography noWrap variant={'body2'}>
                                        {getDisplayProjectStatus(itm)}
                                    </Typography>
                                </Paper>
                            </Grid>

                            {isProcessing && !isResearcher && (
                                <Grid container item xs={12} alignItems="center" style={{ paddingTop: '10px' }}>
                                    <Tooltip title={`${submitTypeName}`}>
                                        {/* <Typography noWrap variant={'body2'}> */}
                                        <li
                                            style={{
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                fontFamily: 'Prompt',
                                                fontSize: '14px',
                                                color: submittedStatusColor,
                                            }}
                                        >
                                            {submitTypeName}
                                        </li>
                                        {/* </Typography> */}
                                    </Tooltip>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        )
    }
    const checkStatusColor = (itm: ItemListType) => {
        let projectStatusBackgroundColor = ''
        let statusTextColor = ''
        let submittedStatusColor = ''

        switch (itm.projectStatusID) {
            case projectStatus.rejected:
                // code block ไม่อนุมัติ
                projectStatusBackgroundColor = statusColorConstant.statusReject.backgroundColor
                // statusTextColor = statusColorConstant.statusReject.textColor
                break
            case projectStatus.closed:
                // code block ปิดโครงการ
                projectStatusBackgroundColor = statusColorConstant.statusClose.backgroundColor
                // statusTextColor = statusColorConstant.statusClose.textColor
                break
            case projectStatus.notScope:
                // code block ไม่เข้าข่าย
                projectStatusBackgroundColor = statusColorConstant.noScope.backgroundColor
                // statusTextColor = statusColorConstant.noScope.textColor
                break
            case projectStatus.terminate:
                // code block ยุติโครงการ
                projectStatusBackgroundColor = statusColorConstant.terminate.backgroundColor
                // statusTextColor = statusColorConstant.terminate.textColor
                break
            case projectStatus.processing:
                // กำลังดำเนินการ
                projectStatusBackgroundColor = statusColorConstant.status15.backgroundColor
                // statusTextColor = statusColorConstant.status15.textColor
                break
            case projectStatus.completed:
                // ดำเนินการเสร็จสิ้น
                projectStatusBackgroundColor = statusColorConstant.status8.backgroundColor
                // statusTextColor = statusColorConstant.status8.textColor
                break
            case projectStatus.withdraw:
                //ถอนโครงการ
                projectStatusBackgroundColor = statusColorConstant.withdraw.backgroundColor
                break
            default:
                // statusId = null (ร่าง)
                projectStatusBackgroundColor = statusColorConstant.status1.backgroundColor
                // statusTextColor = statusColorConstant.status1.textColor

                break
        }

        switch (itm.submittedStatusID) {
            case statusColorConstant.status1.statusID:
                // code block
                submittedStatusColor = statusColorConstant.status1.backgroundColor

                statusTextColor = statusColorConstant.status1.textColor
                break

            case statusColorConstant.status2.statusID:
                // code block

                submittedStatusColor = statusColorConstant.status2.backgroundColor
                statusTextColor = statusColorConstant.status2.textColor

                break
            case statusColorConstant.status3.statusID:
                submittedStatusColor = statusColorConstant.status3.backgroundColor
                statusTextColor = statusColorConstant.status3.textColor

                break
            case statusColorConstant.status4.statusID:
                submittedStatusColor = statusColorConstant.status4.backgroundColor
                statusTextColor = statusColorConstant.status4.textColor

                break
            case statusColorConstant.status18.statusID:
                submittedStatusColor = statusColorConstant.status18.backgroundColor
                statusTextColor = statusColorConstant.status18.textColor

                break
            case statusColorConstant.status5.statusID:
                submittedStatusColor = statusColorConstant.status5.backgroundColor
                statusTextColor = statusColorConstant.status5.textColor

                break
            case statusColorConstant.status6.statusID:
                submittedStatusColor = statusColorConstant.status6.backgroundColor
                statusTextColor = statusColorConstant.status6.textColor

                break
            case statusColorConstant.status7.statusID:
                submittedStatusColor = statusColorConstant.status7.backgroundColor
                statusTextColor = statusColorConstant.status7.textColor

                break
            case statusColorConstant.status8.statusID:
                submittedStatusColor = statusColorConstant.status8.backgroundColor
                statusTextColor = statusColorConstant.status8.textColor

                break
            case statusColorConstant.status9.statusID:
                submittedStatusColor = statusColorConstant.status9.backgroundColor
                statusTextColor = statusColorConstant.status9.textColor

                break
            case statusColorConstant.status10.statusID:
                submittedStatusColor = statusColorConstant.status10.backgroundColor
                statusTextColor = statusColorConstant.status10.textColor

                break
            case statusColorConstant.status11.statusID:
                submittedStatusColor = statusColorConstant.status11.backgroundColor
                statusTextColor = statusColorConstant.status11.textColor

                break
            case statusColorConstant.status12.statusID:
                submittedStatusColor = statusColorConstant.status12.backgroundColor
                statusTextColor = statusColorConstant.status12.textColor
                break
            case statusColorConstant.status14.statusID:
                // code block
                submittedStatusColor = statusColorConstant.status14.backgroundColor
                statusTextColor = statusColorConstant.status14.textColor
                break
            case statusColorConstant.status17.statusID:
                // code block
                submittedStatusColor = statusColorConstant.status17.backgroundColor
                statusTextColor = statusColorConstant.status17.textColor
                break
            // case statusColorConstant.status15.statusID:
            //     // กำลังดำเนินการ
            //     submittedStatusColor = statusColorConstant.status15.backgroundColor
            //     statusTextColor = statusColorConstant.status15.textColor
            //     break
            case statusColorConstant.resultOfConsideration.statusID:
                // code block
                submittedStatusColor = statusColorConstant.resultOfConsideration.backgroundColor
                statusTextColor = statusColorConstant.resultOfConsideration.textColor
                break
            case statusColorConstant.noScope.statusID:
                // code block
                submittedStatusColor = statusColorConstant.noScope.backgroundColor
                statusTextColor = statusColorConstant.noScope.textColor
                break
            case statusColorConstant.terminate.statusID:
                // code block
                submittedStatusColor = statusColorConstant.terminate.backgroundColor
                statusTextColor = statusColorConstant.terminate.textColor
                break
            case statusColorConstant.withdraw.statusID:
                // code block
                submittedStatusColor = statusColorConstant.withdraw.backgroundColor
                statusTextColor = statusColorConstant.withdraw.textColor
                break
            case statusColorConstant.proceedingMemoMessage.statusID:
                // ดำเนินการทำใบบันทึกข้อความ
                submittedStatusColor = statusColorConstant.proceedingMemoMessage.backgroundColor
                statusTextColor = statusColorConstant.proceedingMemoMessage.textColor
                break
            case statusColorConstant.waitingEditProject.statusID:
                // รอแก้ไขโครงการ
                submittedStatusColor = statusColorConstant.waitingEditProject.backgroundColor
                statusTextColor = statusColorConstant.waitingEditProject.textColor
                break
            default:
                // statusId = null (ร่าง)
                submittedStatusColor = statusColorConstant.status1.backgroundColor
                statusTextColor = statusColorConstant.status1.textColor

                break
        }

        return { submittedStatusColor, statusTextColor, projectStatusBackgroundColor }
    }

    return (
        <Container maxWidth="lg">
            <Grid container spacing={2} id={'searchDiv'}>
                <Grid item xs={12}>
                    <SearchAccordion title="ภาพรวมโครงการ" defaultExpanded={isIrb1}>
                        <Dashboard />
                    </SearchAccordion>
                </Grid>
                <Grid item xs={12}>
                    <SearchAccordion title={translate.get('LABEL.PROJECT_MANAGEMENT')}>
                        <SearchForm
                            onGetListItem={getListItem}
                            isResearcher={isResearcher}
                            isChairman={isChairman}
                            onClickClear={onClickClear}
                            initialValue={initialValueForm}
                        />
                    </SearchAccordion>
                </Grid>
                <Grid item xs={12}>
                    <Result
                        pendingProps={pendingProps}
                        data={listItem}
                        onClickEdit={onClickEdit}
                        onClickCreate={onClickCreate}
                        isResearcher={isResearcher}
                        isSumItem={isSumItem}
                    />
                </Grid>
            </Grid>
        </Container>
    )
}

//Controller
const Search = (props: searchTypes.SearchType) => {
    const {} = props
    const searchModel = useSearch({})
    return <SearchView {...searchModel} />
}

export default Search

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        item: {
            // display: 'flex',
            // alignItems: 'center',
            padding: theme.spacing(3),
            margin: theme.spacing(2, 0),
            // border: '1px solid #bdbdbd',
            // borderRadius: 4,
            // transition: '0.3s',
            // position: 'relative',
            '&:hover': {
                border: `1px solid ${theme.palette.primary.main}`,
            },
        },
        paper: {
            height: 'calc(100% + 0px)',
            width: '100%',
        },
        paperFromSearch: {
            width: '100%',
            padding: '30px',
            marginBottom: '10px',
        },
        headTbl: {
            paddingTop: '15px',
            paddingBottom: '15px',
            paddingLeft: '10px',
            fontSize: '20px',
        },
        div: {
            marginTop: '20px',
            paddingRight: '10px',
            cursor: 'pointer',
        },
        borderRadius: {
            border: '2px solid rgba(0, 0, 0, .125)',
            background: '#f1efef',
        },
        btnSearch: {
            textAlign: 'right',
            marginTop: '30px',
        },
        btnAdd: {
            '&:hover': {
                backgroundColor: '#ffffff',
                boxShadow: 'none',
            },
        },
        btnIcon: {
            padding: '8px',
            background: '#f1efef',
        },
        paperProjectCode: {
            padding: '10px',
            // background: '#f3f3f3',
            width: '120px',
            textAlign: 'center',
            border: 'unset',
        },
        paperProjectStatus: {
            padding: '10px',

            width: 'auto',
            textAlign: 'center',
            borderRadius: '20px',
        },
        paperProjectStatusMobile: {
            // padding: '10px',
            height: '15px',
            width: '15px',
            borderRadius: '20px',
        },
        hoverRow: {
            cursor: 'pointer',
            '&:hover': { border: '1px solid #db5f8e !important' },
        },
        btnEdit: {
            boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
            height: '44px',
            marginRight: '1px',
        },
        paperList: {
            '&:hover': { border: '1px solid #db5f8e !important' },
        },
        multiLineEllipsis: {
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': 1,
            '-webkit-box-orient': 'vertical',
        },
    }),
)
